import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const clickUzLink = (
  invoiceNumber?: string,
  amount?: string,
  service_id = '67019',
) => {
  return `https://my.click.uz/services/pay?service_id=${service_id}&merchant_id=35695&communal_param=4&transaction_param=${invoiceNumber}&amount=${amount}`;
};
